var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSes = function SvgSes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10156 10.4375C2.46875 10.4375 0.335938 8.29688 0.335938 5.66406C0.335938 3.03906 2.47656 0.898438 5.10156 0.898438C7.73438 0.898438 9.875 3.03906 9.875 5.66406C9.875 8.29688 7.73438 10.4375 5.10156 10.4375ZM16.8828 10.4375C14.25 10.4375 12.1172 8.29688 12.1172 5.66406C12.1172 3.03906 14.2578 0.898438 16.8828 0.898438C19.5156 0.898438 21.6562 3.03906 21.6562 5.66406C21.6562 8.29688 19.5156 10.4375 16.8828 10.4375ZM5.10156 8.41406C6.61719 8.41406 7.85938 7.17188 7.85938 5.66406C7.85938 4.15625 6.61719 2.91406 5.10156 2.91406C3.59375 2.91406 2.35938 4.14844 2.35938 5.66406C2.35938 7.1875 3.59375 8.41406 5.10156 8.41406ZM16.8828 8.41406C18.3984 8.41406 19.6406 7.17188 19.6406 5.66406C19.6406 4.15625 18.3984 2.91406 16.8828 2.91406C15.375 2.91406 14.1406 4.14844 14.1406 5.66406C14.1406 7.1875 15.375 8.41406 16.8828 8.41406Z",
    fill: "#EDA858"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ses.ef8fdacc.svg";
export { ForwardRef as ReactComponent };